var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('HeroText',{attrs:{"title":_vm.$t('error.title')}},[_c('p',[_vm._v(_vm._s(_vm.errorMessage))])]),_c('div',{staticClass:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }